module.exports = ":host {display:block;}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/jobs/job-description/job-description.component.css
// module id = ./src/app/main/content/jobs/job-description/job-description.component.css
// module chunks = main